export default {
  'SimpleDatePicker.allTime': 'Все время',
  'SimpleDatePicker.lastWeek': 'Неделя',
  'SimpleDatePicker.lastMonth': 'Месяц',
}
